import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import { useImage } from '@/shared/composables/image'

interface IProps {
  imgId?: string
  src?: string
  srcset?: string
  type?: 'avatar' | 'event'
  height: number | string
  width: number | string
  lazy?: boolean
  contain?: boolean
  alt?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BKImage',
  props: {
    imgId: { default: '' },
    src: { default: '' },
    srcset: null,
    type: { default: 'event' },
    height: null,
    width: null,
    lazy: { type: Boolean, default: false },
    contain: { type: Boolean, default: false },
    alt: { default: '' }
  },
  setup(__props: any) {

const props = __props as { imgId: string, src: string, srcset?: string, type: 'avatar' | 'event', height: number | string, width: number | string, lazy: boolean, contain: boolean, alt: string };



const { getImageById } = useImage()

const srcAttrs = computed(() => {
  if (props.src) {
    return {
      src: props.src,
      srcset: props.srcset,
    }
  }

  return {
    src: getImageById(props.imgId, +props.width, +props.height, props.type),
    srcset: `${getImageById(props.imgId, +props.width * 2, +props.height * 2, props.type)} 2x`,
  }
})

return { __sfc: true,props, getImageById, srcAttrs }
}

})